import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../Assets/css/Login.css";
import Cover from "../../Assets/img/default-cover-image.svg";
import axios from "axios";
import store from "store";
import Loader from "../../Components/MainLayout/Loader";
const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class Login extends Component {
  state = {
    values: {
      contact: "",
      password: "",
    },
    schooldata: [],
    loading: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "SchoolApp | Login";
    this.fetch({ api_url: axios.defaults.baseURL });
  }

  fetch = (params = {}) => {
    axios
      .get("/api/schoolinfo", {
        params: { ...params },
        type: "json",
        headers: {
          Authorization: ``,
        },
      })
      .then((res) => {
        this.setState({ schooldata: res.data[0] }, () => {});
        store.set("session", res.data[0].session[0]);
        store.set("school_info", res.data[0]);
      });
  };

  fetchSession = (params = {}) => {
    axios.get(`/api/session`, { params: { ...params } }).then((res) => {
      store.set("session", res.data[0]);
    });
  };

  handleInputChange = (e) => {
    this.setState({
      values: { ...this.state.values, [e.target.name]: e.target.value },
    });
  };

  onFinish = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "user/LOGIN",
      payload: this.state.values,
    });
  };
  render() {
    const { schooldata } = this.state;
    return (
      <div>
        <div
          className="th-login-cover"
          style={{
            backgroundImage: `url(${
              schooldata?.dashboard_bg ? schooldata?.dashboard_bg : Cover
            })`,
          }}
        ></div>

        <div
          style={{
            zIndex: 10,
            background: "linear-gradient(-45deg, #3023AE 0%, #f09 100%)",
          }}
          className="container th-login-container col-12 "
        >
          <div className="d-flex pb-4 pt-4 align-items-center">
            <span>
              <div className="th-login-profile-wrap rounded">
                <div
                  className="th-login-profile"
                  style={{
                    backgroundImage: `url(${
                      schooldata.logo ? schooldata.logo : Cover
                    })`,
                  }}
                ></div>
              </div>
            </span>
            <span className="th-12 th-medium pl-2">
              <p className="mb-0 th-white">{schooldata.school_name}</p>
              <p className="mb-0 th-white th-10">{schooldata.school_address}</p>
            </span>
          </div>
          <div className="th-12 th-medium th-white">Welcome</div>
          <div className="th-10 th-medium th-white">
            Please login to continue.
          </div>
          <form onSubmit={this.onFinish} className="pt-4">
            <div className="input-group input-group pb-2">
              <input
                className="th-input-primary form-control"
                name="contact"
                type="text"
                value={this.state.contact}
                onChange={this.handleInputChange}
                placeholder="Username"
              ></input>
            </div>
            <div className="input-group input-group pb-2">
              <input
                className="th-input-primary form-control"
                name="password"
                type="password"
                value={this.state.password}
                onChange={this.handleInputChange}
                placeholder="Password"
              ></input>
            </div>
            <div className="d-flex justify-content-end">
              {this.state.loading && !this.props.user.wrong ? (
                <div className="my-1 pr-2">
                  <Loader />
                </div>
              ) : null}
              <button type="submit" className="th-btn-primary px-4 py-2">
                Login
              </button>
            </div>
            <div className="d-flex justify-content-center mt-4 th-white">
              <Link
                className="th-12 th-link th-white pl-1"
                style={{ textDecoration: "none" }}
                to="/forgotpassword"
              >
                Forgot password?
              </Link>
            </div>
            <div className="d-flex justify-content-center th-white mt-4 pb-4">
              <a href="https://gungunerp.com/">
                <div className="th-10 th-white">
                  Powered By <span className="th-white">GungunERP</span>
                </div>
              </a>
            </div>
            {this.props.user.wrong ? (
              <div className="d-flex justify-content-center mt-4 pb-4 th-white">
                <h4 className="th-16 th-white">
                  Username And Password Invalid
                </h4>
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(Login);
